module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('client-blank-form', _vm._b({
    attrs: {
      "submit-label": "Сохранить",
      "form-type": "edit",
      "errors": _vm.errors
    },
    on: {
      "submit": _vm.processClientForm
    }
  }, 'client-blank-form', _vm.$attrs, false))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65c5d22b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/client/ClientEditForm.vue
// module id = 664
// module chunks = 0